import React from "react";
import { Zap } from "lucide-react";
import { THEME_COLORS } from "../themes/DarkLight";
import useThemeHook from "../hooks/useThemeHook";
import { useTranslationHook } from "../hooks/useTranslationHook";

interface TurboChargeCardProps {
  count: number;
  expiry?: any;
  onClick: () => void;
}

const TurboChargeCard: React.FC<TurboChargeCardProps> = ({ count, expiry, onClick }) => {
  const theme = useThemeHook();
  const getTranslationText = useTranslationHook();
  
  const isActive = expiry && new Date(expiry.seconds * 1000) > new Date();
  const progress = (count / 10) * 100;

  if (isActive) {
    return (
      <div className="bg-gradient-to-r from-yellow-400 to-orange-500 rounded-2xl p-4 text-white shadow-lg overflow-hidden relative">
        <div className="absolute top-0 right-0 p-4 opacity-20">
          <Zap size={80} strokeWidth={3} />
        </div>
        <div className="relative z-10">
          <div className="flex items-center gap-2 mb-1">
            <Zap size={20} fill="white" />
            <span className="font-bold text-lg uppercase tracking-wider">Turbo Active!</span>
          </div>
          <p className="text-sm opacity-90">Your mining speed is boosted by 5x! ⚡🚀</p>
          <div className="mt-2 text-xs font-mono bg-white/20 inline-block px-2 py-1 rounded">
            Expires in: {Math.max(0, Math.floor((new Date(expiry.seconds * 1000).getTime() - new Date().getTime()) / 60000))}m
          </div>
        </div>
      </div>
    );
  }

  return (
    <button 
      onClick={onClick}
      className="w-full bg-white border border-gray-200 rounded-2xl p-4 text-left hover:border-orange-300 transition-all active:scale-[0.98]"
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center">
            <Zap size={18} className="text-orange-600" fill="currentColor" />
          </div>
          <div>
            <h3 className="font-bold text-gray-800">Turbo Charge</h3>
            <p className="text-[10px] text-gray-400 uppercase tracking-tighter">Ad Marathon Challenge</p>
          </div>
        </div>
        <div className="text-right">
          <span className="text-lg font-black text-orange-600 font-mono">{count}/10</span>
        </div>
      </div>

      <div className="relative w-full h-2 bg-gray-100 rounded-full overflow-hidden mb-2">
        <div 
          className="absolute top-0 left-0 h-full bg-orange-500 transition-all duration-500 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
      
      <p className="text-[11px] text-gray-500">
        Watch 10 ads to unlock <span className="text-orange-600 font-bold">5x Mining Power</span> for 1 hour!
      </p>
    </button>
  );
};

export default TurboChargeCard;
